module.exports = __webpack_public_path__ + "static/media/barbegal_muehlen_tn.940239b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/barbegal_muehlen_tn.jpg
// module id = 710
// module chunks = 0